module.exports = __webpack_public_path__ + "images/5a168c437ac524714b05bc80e5ecd72a8485dfc17369de18f78c64bcd6ba04e3.svg";